import wrapWithProvider from './src/components/wrap-with-provider';
import './src/styles/global.css';
export const wrapRootElement = wrapWithProvider;

export const shouldUpdateScroll = ({ routerProps, prevRouterProps }) => {
  const oldPath = prevRouterProps?.location?.pathname;
  const newPath = routerProps.location.pathname;
  return oldPath !== newPath;
};

export const onRouteUpdate = () => {
  if (typeof window !== 'undefined' && (window as any).$TB) {
    (window as any).$TB.hooks.fireEvent('pageChange', null, {
      sendBeacon: true,
    });
  }
};
